<template>
  <ExcursionFilterPopupWrapper
    :title
    :items-count="itemsCount"
    :static-title="t('format.title')"
    :is-modal-only="isFullscreen"
    :is-active="isActive"
    filter-key="type"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="isScroll"
    @apply="handleApply"
  >
    <ExcursionFiltersFormatContent />
  </ExcursionFilterPopupWrapper>
</template>

<script setup lang="ts">
  import { ExcursionFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  import { useExcursionFilterFormatTitle } from '@/features/filter/format/composables/excursion/useExcursionFilterFormatTitle.ts';
  import { useExcursionFiltersStore, type TExcursionFiltersState } from '@/entities/filter/store/excursion';
  import ExcursionFiltersFormatContent from './ExcursionFiltersFormatContent.vue';
  import { locales } from '../../i18n';
  import { useComponentI18n } from '@/shared/composables/useComponentI18n.ts';

  interface Props {
    isFullscreen: boolean;
    isScroll: boolean;
  }

  interface Emits {
    (e: 'apply', isForced: boolean, filterData?: Partial<TExcursionFiltersState>): void;
  }

  defineProps<Props>();

  const emit = defineEmits<Emits>();

  const { t } = useComponentI18n(locales);

  const filtersStore = useExcursionFiltersStore();

  const { title, itemsCount, isActive } = useExcursionFilterFormatTitle(locales.ru);

  const isDisabledResetButton = computed(() => {
    return !filtersStore.state.type.length;
  });

  const handleApply = (isForced: boolean) => {
    const filterData: Partial<TExcursionFiltersState> = {
      type: filtersStore.searchState.type,
    };
    emit('apply', isForced, filterData);
  };
</script>

<style lang="scss"></style>
